export default __webpack_public_path__ + "static/media/sass.c5da83bb.png";